var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"exportar-codigos","title":"Exportación de códigos"},on:{"close":() => _vm.close(false)}},[_c('b-row',{staticClass:"text-center"},[_c('b-col',{staticClass:"mb-3",attrs:{"cols":"12"}},[_c('h3',[_vm._v("Se está procesando la generación del fichero. Recibirá una notificación cuando esté listo.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }